export const CHILD_MIN_AGE = 2
export const CHILD_MAX_AGE = 12
export const ADULT_MIN_AGE = 13
